import React, { useEffect } from 'react'; // Importe o useEffect
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import './App.css';
import './css/Fonts.css';
import Login from './components/Login';
import RecuperarSenha from './components/RecuperarSenha';
import Home from './components/Home';
import HomeAluno from './components/Home_aluno';
import Avaliacao from './components/Avaliacao';
import { iniciarAjusteDasCaixasInfo } from './utils/caixasInfo';

function useTheme(userData) {
  useEffect(() => {
    if (userData) {
      if (userData.colorStyle) {
        document.documentElement.setAttribute('data-color-style', userData.colorStyle);
      }
      if (userData.colorTheme) {
        document.documentElement.setAttribute('data-theme', userData.colorTheme);
      }
    }
  }, [userData]);
}

function App() {
  const savedUser = JSON.parse(localStorage.getItem('@AppAcademia:user'));
  useTheme(savedUser);

  // Mantém as caixas de informação dentro da área visível, sem alargar a página.
  useEffect(() => { iniciarAjusteDasCaixasInfo(); }, []);
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login/>}/>
        <Route path="/recuperar-senha" element={<RecuperarSenha/>}/>
        <Route path="/home" element={<Home/>}/>
        <Route path="/home-aluno" element={<HomeAluno/>}/>
        <Route path="/avaliacao" element={<Avaliacao/>}/>
        <Route path="/avaliacao/:id" element={<Avaliacao/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;